export default "__VITE_ASSET__8029f011__"